import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { FgInspection } from "./fg-inspection.entity";
@Entity('fgInspection_samples')
export class FgInspectionSamples {
    @PrimaryGeneratedColumn('increment', {
        name: 'fgInspection_samples_id',
    })
    fgInspectionSampleId: number;

    @Column('int', {
        name: 'fgInspection_id'
    })
    fgInspectionId: number

    @Column({
        type: 'int',
        nullable: false,
        name: 'sample_number'
    })
    sampleNo: number;

    @Column({
        nullable: true,
        name: 'sample_time',
    })
    time: Date;


    @Column({
        type: 'int',
        nullable: false,
        name: 'temperature'
    })
    temperature: number;

   

    @Column({
        type: 'int',
        nullable: true,
        name: 'filling_weight'
    })
    fillingWeight: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'frozen_weight'
    })
    frozenWeight: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'deglazed_weight'
    })
    deglazedWeight: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'net_weight'
    })
    netWeight: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'sub_sample_weight'
    })
    subSampleWeight: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'frozen_count'
    })
    frozenCount: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'deglazed_count'
    })
    deglazedCount: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'net_count'
    })
    netCount: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'total_pieces'
    })
    totalPieces: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'glazed_percent'
    })
    glazePercent: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'total_ounce'
    })
    totalOunce: number;

    @Column("varchar", {
        nullable: true,
        length: 20,
        name: "cluster"
    })
    cluster: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "general_appearance"
    })
    generalAppearance: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "general_odour"
    })
    generalOdour: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "freshness"
    })
    freshness: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "texture"
    })
    texture: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "dehydration"
    })
    dehydration: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "discoloration"
    })
    discoloration: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "deterioration"
    })
    deterioration: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "peeling"
    })
    peeling: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "hanging_meat"
    })
    hangingMeat: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "black_spot"
    })
    blackSpot: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "broken"
    })
    broken: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "wrong_cut"
    })
    wrongCut: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "shells"
    })
    shells: string;

    @Column("varchar", {
        nullable: false,
        length: 20,
        name: "foreign_matter"
    })
    foreignMatter: string;

    @Column({
        type: 'int',
        nullable: true,
        name: 'uniformity_big'
    })
    uniformityBig: number;
    @Column({
        type: 'int',
        nullable: true,
        name: 'uniformity_small'
    })
    uniformitySmall: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'uniformity_ratio'
    })
    uniformityRatio: number;

    @Column({
        type: 'varchar',
        nullable: true,
        name: 'product_Met_Spec'
    })
    productMetSpec: string;

    @Column({
        nullable: false,
        name: "best_before"
    })
    bestBefore: Date;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "remarks"
    })
    remarks: string;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })

    versionFlag: number;

    @ManyToOne(type => FgInspection, rmEval => rmEval.samplesInfo, { nullable: false })
    @JoinColumn({ name: 'fgInspection_id' })
    fgInspectionInfo: FgInspection;
}